/**
 * 认证 API 封装
 */

// 认证 Worker 的 URL
const AUTH_API_BASE = 'https://xtool-auth.gson.workers.dev';

/**
 * 用户登录
 * @param {string} username - 用户名
 * @param {string} password - 密码
 * @returns {Promise<{success: boolean, token?: string, user?: object, error?: string}>}
 */
export async function login(username, password) {
    try {
        const response = await fetch(`${AUTH_API_BASE}/auth/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ username, password })
        });

        const data = await response.json();

        if (response.ok && data.success) {
            return {
                success: true,
                token: data.token,
                expiresIn: data.expiresIn,
                user: data.user
            };
        } else {
            return {
                success: false,
                error: data.error || '登录失败'
            };
        }
    } catch (e) {
        console.error('Login error:', e);
        return {
            success: false,
            error: '网络错误，请稍后重试'
        };
    }
}

/**
 * 验证 Token
 * @param {string} token - JWT Token
 * @returns {Promise<{valid: boolean, user?: object, error?: string}>}
 */
export async function verifyToken(token) {
    try {
        const response = await fetch(`${AUTH_API_BASE}/auth/verify`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        const data = await response.json();

        return {
            valid: data.valid,
            user: data.user,
            error: data.error
        };
    } catch (e) {
        console.error('Verify token error:', e);
        return {
            valid: false,
            error: '网络错误'
        };
    }
}

/**
 * 用户登出
 * @param {string} token - JWT Token
 * @returns {Promise<{success: boolean, error?: string}>}
 */
export async function logout(token) {
    try {
        const response = await fetch(`${AUTH_API_BASE}/auth/logout`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        const data = await response.json();

        return {
            success: data.success,
            error: data.error
        };
    } catch (e) {
        console.error('Logout error:', e);
        return {
            success: false,
            error: '网络错误'
        };
    }
}

/**
 * 刷新 Token
 * @param {string} token - 当前 JWT Token
 * @returns {Promise<{success: boolean, token?: string, error?: string}>}
 */
export async function refreshToken(token) {
    try {
        const response = await fetch(`${AUTH_API_BASE}/auth/refresh`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        const data = await response.json();

        if (response.ok && data.success) {
            return {
                success: true,
                token: data.token,
                expiresIn: data.expiresIn
            };
        } else {
            return {
                success: false,
                error: data.error
            };
        }
    } catch (e) {
        console.error('Refresh token error:', e);
        return {
            success: false,
            error: '网络错误'
        };
    }
}
